<template>
	<div class="animate_animated animate__slideInRight">
		<!-- Header -->
		<div class="fixed w-full top-0 left-0 z-20">
			<div class="bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/80">
				 <div class="h-1 bg-gradient-to-r from-[#00cdac] to-[#92ffe1]"></div>
				 <div class="flex items-center px-4 py-4">
					<div class="w-1/2">
				<div class="flex items-center w-full">
					<a  @click="$router.go(-1)"><img src="@/assets/back-arrow.svg" alt=""></a>
					<span class="text-base text-content font-medium ml-4">Matches</span>
				</div>
			</div>
			<div class="w-1/2">
				<div class="flex items-center justify-end">
					<a href="" class="mx-2"><img src="@/assets/share.svg" alt=""></a>
					<a href="" class="mx-2"><img src="@/assets/search-icon.svg" alt=""></a>
					<a href="" class="mx-2"><img src="@/assets/filter-icon.svg" alt=""></a>
				</div>
			</div>
				 </div>
			
		</div>
		</div>
		<div class="pt-16 mt-2">
<div class="shadow-ct bg-white my-2">
			<div class="flex items-center p-4">
				<div class="w-1/2">
					<div class="px-2">
						<span class="text-sm text-content font-medium">Rahul Roy</span>
					</div>
				</div>
				<div class="w-1/2">
					<div class="flex items-center justify-end">
						<a href="" class="mx-4"><img src="@/assets/whatsapp.svg" alt=""></a>
						<a href="" class="mx-4"><img src="@/assets/email-icon.svg" alt=""></a>
						<a href="" class="mx-4"><img src="@/assets/phone-icon.svg" alt=""></a>
					</div>
				</div>
			</div>
		</div>
			<div class="shadow-ct bg-white my-2">
			<div class="flex items-center p-4">
				<div class="w-1/2">
					<div class="px-2">
						<span class="text-sm text-content font-medium">Rahul Roy</span>
					</div>
				</div>
				<div class="w-1/2">
					<div class="flex items-center justify-end">
						<a href="" class="mx-4"><img src="@/assets/whatsapp.svg" alt=""></a>
						<a href="" class="mx-4"><img src="@/assets/email-icon.svg" alt=""></a>
						<a href="" class="mx-4"><img src="@/assets/phone-icon.svg" alt=""></a>
					</div>
				</div>
			</div>
		</div>
		</div>
		
	</div>
</template>
<style scoped>

</style>